import axios from 'axios'

export default () => {
    const locationPage = document.querySelector('[data-location-page]')
    const modalId = document.querySelector('[data-modal-id]')
    const autoOpenModal = document.querySelector('[data-auto-open-modal]')

    if (locationPage) {
        const endpoint = locationPage.dataset.locationEndpoint
        const pageId = locationPage.dataset.locationPage
        axios({
            method: 'post',
            url: `${endpoint}?pageId=${pageId}`,
        })
            .then()
            .catch((err) => {
                console.warn(err)
            })
    }

    const autoOpenModalValue = autoOpenModal !== null ? autoOpenModal.dataset.autoOpenModal : 'true'
    if (modalId && autoOpenModalValue === 'true') {
        const id = modalId.dataset.modalId
        window.history.pushState(
            null,
            null,
            `${window.location.pathname}?modal=${id}`,
        )
    }
}
